import produce from "immer";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchCountItems, updateCountItems, createCount, deleteCount } from '../../api/inventory/count_items'

const initialState = {
    isLoading: false,
    error: false,
    errors: null,
    data: [],
};


export const deleteCountAsync = createAsyncThunk(
    'inventory_counts/deleteCountAsync', 
    async (payload) => {


        let response = await deleteCount(payload);
        
        // If errors, reject and return response
        if (response.errors) return false

        // If all good, return response.
        return response;
    }
)


// Updates or creates new items
export const updateCountItemsAsync = createAsyncThunk(
    'inventory_count_items/updateCountItemsAsync', 
    async (payload) => {
        let response = await updateCountItems(payload);
        
        // If errors, reject and return response
        if (response.errors.length > 0) return false

        // If all good, return response.
        return response;
    }
)

export const getCountItemsAsync = createAsyncThunk(
    'inventory_count_items/getCountItemsAsync', 
    async (id, payload) => {

        // if (! controller) return false;
        let response = await fetchCountItems(id, payload);
        
        // If errors, reject and return response
        // if (response.errors) return false;

        // If all good, return response.
        return response;
})



const InventoryCountItemSlice = createSlice({
    name: 'inventory_count_items',
    initialState,
    reducers: {
    },
    extraReducers : (builder) => {
        builder.addCase(getCountItemsAsync.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(getCountItemsAsync.fulfilled, (state, action ) => {
            state.isLoading = false;
            // Handle different response formats
            let items = [];
            if (Array.isArray(action.payload)) {
                items = action.payload;
            } else if (action.payload?.data) {
                // Backend returns { success: true, data: [...] }
                items = Array.isArray(action.payload.data) ? action.payload.data : [];
            } else if (action.payload?.success && Array.isArray(action.payload.data)) {
                items = action.payload.data;
            } else {
                items = [];
            }
            // Sort items by id (or created_at) to maintain consistent order
            state.data = [...items].sort((a, b) => {
                // First try created_at if available
                if (a.created_at && b.created_at) {
                    return new Date(a.created_at) - new Date(b.created_at);
                }
                // Fallback to id
                return (a.id || 0) - (b.id || 0);
            });
        })
        .addCase(getCountItemsAsync.rejected, (state) => {
            state.isLoading = false;
            state.error = true;
            state.errors = []
        })
        .addCase(updateCountItemsAsync.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(updateCountItemsAsync.fulfilled, (state, action ) => {
            return produce(state, (draftState) => {
                // Handle both array response and object with data property
                let items = [];
                if (Array.isArray(action.payload)) {
                    items = action.payload;
                } else if (action.payload?.data && Array.isArray(action.payload.data)) {
                    items = action.payload.data;
                } else {
                    items = [];
                }
                // Sort items by id (or created_at) to maintain consistent order
                draftState.data = [...items].sort((a, b) => {
                    // First try created_at if available
                    if (a.created_at && b.created_at) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    }
                    // Fallback to id
                    return (a.id || 0) - (b.id || 0);
                });
                draftState.isLoading = false;
                draftState.errors = action.payload?.errors || null;
            })
        })
        .addCase(updateCountItemsAsync.rejected, (state) => {
            state.isLoading = false;
            state.error = true;
            state.errors = []
        })
        .addCase(deleteCountAsync.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(deleteCountAsync.fulfilled, (state, action ) => {
            return produce(state, (draftState) => {
                // Handle both array response and object with data property
                if (Array.isArray(action.payload)) {
                    draftState.data = action.payload;
                } else if (action.payload?.data && Array.isArray(action.payload.data)) {
                    draftState.data = action.payload.data;
                } else {
                    // If delete was successful, refetch will update the data
                    draftState.data = draftState.data || [];
                }
                draftState.isLoading = false;
            })
        })
        .addCase(deleteCountAsync.rejected, (state) => {
            state.isLoading = false;
            state.error = true;
            state.errors = ['Something went wrong when trying to update report type']
        })
    }
})


// export const {} = customerSlice.actions;

export const { reducer } = InventoryCountItemSlice;

export default InventoryCountItemSlice

// export const selectInventoryCountById = (state, itemId) => state.inventory_counts.data.find(item => item.id == itemId)
